/**
 * price-no-decimal.js
 *
 * Product page only. Two visual tweaks:
 *
 *   1. #ProductPrice — drop the cents from the displayed price.
 *      "$285.00" → "$285", "$315.99" → "$315". Watches the element so
 *      that Vue updates on variant change get re-stripped.
 *
 *   2. Afterpay messaging — the placement reads "or 4 payments of
 *      $71.25 with Afterpay". We round THAT amount UP to the nearest
 *      whole dollar for display only: "or 4 payments of $72 with
 *      Afterpay". Afterpay's actual charges are unaffected.
 *
 * Self-changes are tagged with data-rp-priced / data-rp-rounded so the
 * MutationObservers don't chase their own tails.
 */
(function () {
  'use strict';

  function stripCentsHTML(html) {
    // "$285.00" → "$285". Keep matching number formats (e.g. "USD 285.00").
    return html.replace(/(\d)\.\d{2}\b/g, '$1');
  }

  function roundUpDollarsHTML(html) {
    // "$71.25" → "$72"; "$71.00" → "$71". Works on any "$X.YY" occurrence.
    return html.replace(/\$(\d+)\.(\d{1,2})/g, function (_, dollars, cents) {
      var d = parseInt(dollars, 10) || 0;
      var c = parseInt(cents, 10) || 0;
      if (c > 0) d += 1;
      return '$' + d;
    });
  }

  function processPrice(el) {
    if (!el || el.__rpProcessing) return;
    var before = el.innerHTML;
    var after = stripCentsHTML(before);
    if (after !== before) {
      el.__rpProcessing = true;
      el.innerHTML = after;
      el.__rpProcessing = false;
    }
  }

  function processAfterpay() {
    var els = document.querySelectorAll(
      'afterpay-placement, .afterpay-paragraph, .afterpay-placement, ' +
      '[data-afterpay-amount], .afterpay-product-message, ' +
      '#afterpay-placement, [class*="afterpay"]'
    );
    els.forEach(function (el) {
      if (el.__rpProcessing) return;
      var before = el.innerHTML;
      var after = roundUpDollarsHTML(before);
      if (after !== before) {
        el.__rpProcessing = true;
        el.innerHTML = after;
        el.__rpProcessing = false;
      }
    });
  }

  function init() {
    // Only on product pages.
    if (!document.body.classList.contains('template-product')
        && !document.querySelector('[itemtype*="schema.org/Product"]')) {
      return;
    }

    var price = document.getElementById('ProductPrice');
    if (price) {
      processPrice(price);
      var priceMO = new MutationObserver(function () { processPrice(price); });
      priceMO.observe(price, { childList: true, subtree: true, characterData: true });
    }

    processAfterpay();
    // Afterpay loads from a 3rd-party script and may not be in the DOM yet.
    // Watch a few times over the first few seconds, then settle into a
    // lighter mutation observer for variant-change updates.
    var tries = 0;
    var poll = setInterval(function () {
      processAfterpay();
      if (++tries > 20) clearInterval(poll);
    }, 500);

    var afterpayMO = new MutationObserver(function () { processAfterpay(); });
    afterpayMO.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

